export default "__VITE_ASSET__71fc6176__"